/**
 * Rebuy Smart Cart Override
 * This script prevents the native Shopify cart drawer from opening when Rebuy Smart Cart is active.
 * Instead of hiding with CSS (which still runs the drawer), this completely blocks it at the JS level.
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Wait a bit for Rebuy to load
    const checkRebuy = setInterval(() => {
      if (window.Rebuy && window.Rebuy.SmartCart) {
        clearInterval(checkRebuy);
        overrideNativeCartDrawer();
      }
    }, 100);

    // Stop checking after 5 seconds if Rebuy doesn't load
    setTimeout(() => clearInterval(checkRebuy), 5000);
  }

  function overrideNativeCartDrawer() {
    const nativeDrawer = document.querySelector('cart-drawer');
    
    if (!nativeDrawer) {
      console.warn('Native cart drawer not found');
      return;
    }

    // Store the original show method
    const originalShow = nativeDrawer.show.bind(nativeDrawer);

    // Override the show method to use Rebuy instead
    nativeDrawer.show = function() {
      // Check if Rebuy Smart Cart is available
      if (window.Rebuy && window.Rebuy.SmartCart) {
        // Show Rebuy Smart Cart instead
        window.Rebuy.SmartCart.show();
        return; // Don't execute the native drawer show
      } else {
        // Fallback to native drawer if Rebuy isn't available
        originalShow();
      }
    };

    // Also intercept cart icon clicks to use Rebuy
    const cartLinks = document.querySelectorAll('a[href*="/cart"]');
    cartLinks.forEach(link => {
      // Only override if it has aria-controls="cart-drawer" (drawer trigger)
      if (link.getAttribute('aria-controls') === 'cart-drawer') {
        link.addEventListener('click', function(e) {
          if (window.Rebuy && window.Rebuy.SmartCart) {
            e.preventDefault();
            e.stopPropagation();
            window.Rebuy.SmartCart.show();
          }
        }, true); // Use capture phase to intercept before other handlers
      }
    });

    console.log('✅ Rebuy Smart Cart override active - native drawer disabled');
  }

  // Add a helper to manually trigger Rebuy cart (useful for debugging)
  window.showRebuyCart = function() {
    if (window.Rebuy && window.Rebuy.SmartCart) {
      window.Rebuy.SmartCart.show();
    } else {
      console.error('Rebuy Smart Cart not available');
    }
  };
})();
